import React, { useState, useEffect } from "react";
import "./ClassFeedback.css";
import BackBtn from "../../Components/BackBtn/BackBtn";
import SelectOptions from "../../Components/SelectOptions/SelectOptions";
import { useLocation } from "react-router-dom";
import { useAuth } from "../../AuthContext";
import Axios from "axios";
import Alert from "../../Components/Alert/Alert";
import FeedbackItem from "../../Components/FeedbackItem/FeedbackItem";
import { useBaseUrl } from "../../ApiContext";

export default function ClassFeedback() {
  const { userToken } = useAuth();
  const baseUrl = useBaseUrl();
  const location = useLocation();
  const { plans } = location.state || {};
  const [showAlert, setShowAlert] = useState(false);
  const [alertText, setAlertText] = useState("");
  const [conductionOptions, setConductionOptions] = useState([
    { id: 1, title: "آفلاین", label: "OFFLINE", isChecked: false },
    { id: 2, title: "آنلاین", label: "ONLINE", isChecked: false },
    { id: 3, title: "ندیدم", label: "UNSEEN", isChecked: false },
  ]);
  const [trainingLevel, setTrainingLevel] = useState([
    { id: 1, title: "سخت", level: 3, isChecked: false },
    { id: 2, title: "متوسط", level: 2, isChecked: false },
    { id: 3, title: "آسان", level: 1, isChecked: false },
  ]);
  const [selectedWeight, setSelectedWeight] = useState(1);
  const [selectedPlan, setSelectedPlan] = useState(null);
  const [sessionsData, setSessionsData] = useState(null);
  const [comment, setComment] = useState("");
  const [selectedConduction, setSelectedConduction] = useState(null);
  const [selectedLevel, setSelectedLevel] = useState(null);
  const [selectedSessionId, setSelectedSessionId] = useState(null);
  const [selectedSessionIndex, setSelectedSessionIndex] = useState(null);

  useEffect(() => {
    if (plans && plans.length > 0) {
      setSelectedPlan(plans[0].id);
    }
  }, [plans]);

  const handleConductionChange = (option) => {
    setSelectedConduction(option.label);
  };

  const handleTrainingLevelChange = (level) => {
    setSelectedLevel(level.level);
  };

  const handleSelectedWeight = (id) => {
    setSelectedWeight(id);
  };

  const handleSelectedPlan = (item) => {
    const selectedId = plans.filter((plan) => plan.id === item.id)[0].id;
    setSelectedPlan(selectedId);
  };

  const fetchSessionData = async () => {
    try {
      const response = await Axios.get(
        `${baseUrl}/exercise_plan/${selectedPlan}/sessions`,
        {
          headers: {
            Authorization: `Token ${userToken}`,
          },
        }
      );
      setSessionsData(response.data.sessions);
    } catch (error) {
      console.log("Error during getting report sessions data", error);
    }
  };
  useEffect(() => {
    if (userToken && selectedPlan) {
      fetchSessionData();
    }
  }, [userToken, selectedPlan]);

  const handleSessionClick = async (session, index) => {
    setSelectedSessionIndex(index)
    if (session.id) {
      setSelectedSessionId(session.id);
      try {
        const response = await Axios.get(
          `${baseUrl}/report/session/${session.id}/retrieve`,
          {
            headers: {
              Authorization: `Token ${userToken}`,
            },
          }
        );
        setComment(response.data.comment);
        setSelectedConduction(response.data.conduction);
        setSelectedLevel(response.data.training_level);
        setSelectedWeight(response.data.weight_lift);
        const updatedConductionOptions = conductionOptions.map((option) => ({
          ...option,
          isChecked: option.label === response.data.conduction,
        }));
        setConductionOptions(updatedConductionOptions);
        const updatedTrainingLevel = trainingLevel.map((level) => ({
          ...level,
          isChecked: level.level === response.data.training_level,
        }));
        setTrainingLevel(updatedTrainingLevel);
      } catch (error) {
        console.log("Error during getting session retrieve", error);
        setSelectedConduction(null);
        setSelectedLevel(null);
        setSelectedWeight(1);
        setComment("");
        if (session.locked) {
          setShowAlert(true);
          setTimeout(() => {
            setShowAlert(false);
          }, 2000);
          setAlertText("مجاز نیست");
        }
      }
    }
  };

  const handleSubmitSessionData = () => {
    const fetchSubmit = async () => {
      const postData = {
        comment: comment,
        conduction: selectedConduction,
        training_level: selectedLevel,
        weight_lift: selectedWeight,
      };
      setShowAlert(true);
      setTimeout(() => {
        setShowAlert(false);
      }, 2000);
      setAlertText("در حال ثبت گزارش...");
      try {
        const response = await Axios.post(
          `${baseUrl}/report/session/${selectedSessionId}/submit`,
          postData,
          {
            headers: {
              Authorization: `Token ${userToken}`,
            },
          }
        );
        console.log(response);
        setShowAlert(true);
        setTimeout(() => {
          setShowAlert(false);
        }, 2000);
        setAlertText("گزارش با موفقیت ثبت شد");
        fetchSessionData()
      } catch (error) {
        console.log("Error during submiting session data", error);
        setShowAlert(true);
        setTimeout(() => {
          setShowAlert(false);
        }, 2000);
        setAlertText("خطا در برقراری ارتباط");
      }
    };
    if (
      selectedSessionId &&
      selectedConduction &&
      selectedLevel &&
      selectedWeight
    ) {
      fetchSubmit();
    }
    if (
      !selectedSessionId ||
      !selectedConduction ||
      !selectedLevel ||
      !selectedWeight
    ) {
      setShowAlert(true);
      setTimeout(() => {
        setShowAlert(false);
      }, 2000);
    }

    if (!selectedSessionId) {
      setAlertText("لطفا جلسه مورد نظر خود را انتخاب کنید");
    } else if (!selectedConduction) {
      setAlertText("لطفا نحوه حضور در کلاس را تعیین کنید ");
    } else if (!selectedLevel) {
      setAlertText("لطفا سطح دوره را تعیین کنید");
    } else if (!selectedWeight) {
      setAlertText("لطفا وزنه را انتخاب کنید");
    }
  };

  return (
    <div className="gymBg bgContainer">
      <div className="blurOverlay">
        <div className="pageWrapper">
          <div className="pageHeader centeredFlex">
            <BackBtn />
          </div>
          <div className="pageTitle horizontalBorder">
            بازخورد کلاس های ورزشی{" "}
            <img
              src="/images/whiteWeightPack.svg"
              alt="weight"
              className="svgWhiteWeight"
            />
          </div>
          <div className="classFeedback scroll">
            <SelectOptions
              optionsData={
                plans && plans.length > 0
                  ? plans.map((plan) => ({ id: plan.id, name: plan.name }))
                  : []
              }
              onSelect={(item) => handleSelectedPlan(item)}
            />
            <div className="feedbackItems horizontalBorder">
              {sessionsData !== null &&
                sessionsData.length > 0 &&
                sessionsData.map((session, index) => (
                  <FeedbackItem
                    key={session.id}
                    {...session}
                    index={index}
                    label="جلسه"
                    onItemClick={() => handleSessionClick(session, index)}
                    selectedItemIndex={selectedSessionIndex}
                  />
                ))}
            </div>
            <div className="classConduction centeredFlex horizontalBorder">
              <span className="classConductionTitle">حضور در کلاس</span>
              <div className="classConductionOptions centeredFlex">
                {conductionOptions.map((option) => (
                  <label
                    key={option.id}
                    className="classConductionOption centeredFlex"
                  >
                    <span>{option.title}</span>
                    <input
                      type="checkbox"
                      className="radioBtn"
                      checked={
                        option.label === selectedConduction ? true : false
                      }
                      onChange={() => handleConductionChange(option)}
                    />
                    <span className="feedbackCustomRadioBtn"></span>
                  </label>
                ))}
              </div>
            </div>
            <div className="trainingLevel centeredFlex horizontalBorder">
              <span className="trainingLevelTitle">این جلسه چگونه بود؟</span>
              <div className="trainingLevelOptions centeredFlex">
                {trainingLevel.map((level) => (
                  <label
                    key={level.id}
                    className="trainingLevelOption centeredFlex"
                  >
                    <span>{level.title}</span>
                    <input
                      type="checkbox"
                      className="radioBtn"
                      checked={level.level === selectedLevel ? true : false}
                      onChange={() => handleTrainingLevelChange(level)}
                    />
                    <span className="feedbackCustomRadioBtn"></span>
                  </label>
                ))}
              </div>
            </div>
            <div className="weightUsage horizontalBorder centeredFlex">
              <h3 className="weightUsageTitle">میانگین استفاده از وزنه؟</h3>
              <div className="weightUsageOptions scroll centeredFlex">
                {[...Array(99).keys()].map((index) => (
                  <div
                    key={index + 1}
                    className={`weightUsageOption centeredFlex ${
                      selectedWeight === index + 1 ? "activeWeightUsage" : ""
                    }`}
                    onClick={() => handleSelectedWeight(index + 1)}
                  >
                    <img src="/images/singleDamble.svg" alt="weight" />
                    <span>{index + 1} کیلو</span>
                  </div>
                ))}
              </div>
            </div>
            <div className="feedbackCommnet">
              <p className="feedbackCommnetTitle">
                نظر خود را در مورد این جلسه بنویسید:
              </p>
              <textarea
                className="feedbackCommnetField"
                value={comment}
                onChange={(e) => setComment(e.target.value)}
              ></textarea>
            </div>
            <button
              type="button"
              className="nextQuestion"
              onClick={handleSubmitSessionData}
            >
              ارسال
            </button>
          </div>
          <Alert showAlert={showAlert} alertText={alertText} />
        </div>
      </div>
    </div>
  );
}
